<template>
    <div class="show-mp4">
        <template v-if="src">
            <video class="show-video" controls>
                <source :src="src" type="video/mp4">
                <source :src="src" type="video/ogg">
                <source :src="src" type="video/webm">
                <object :data="src" >
                    <embed :src="src" >
                </object>
            </video>
        </template>
    </div>
</template>

<script>
	export default {
		components: {
		},
	    data() {
	        return {
		        src: '', // pdf文件地址
	        }
	    },
	    mounted() {
	        this.initSrc()
	    },
		methods: {
		    initSrc() {
			    this.src = this.$route.query.src
                console.log('src', this.src);
		    },
		},
		created() {
		},
	}
</script>

<style scoped lang="scss">
.show-mp4 {
    width: 100vw;
    height: 100vh;
    min-height: 500px;
    .show-video {
        width: 100%;
        height: 100%;
    }
}
</style>